import { useMutation } from "@apollo/client";
import styled from "@emotion/styled";
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { i18n, mediaQuery, navigate, openCallMeModal, setGlobalLoading, useAppDispatch, useForm } from 'src/common';
import { setInsuranceNumber } from 'src/common/api/apollo/supplementary';
import { Card, CloseIcon, Flex, GroupIcon, HtmlText, HtmlTextLink, MboForm, RequestAgentCardV2, Text } from 'src/components';
import { colors } from "src/theme";
import { AppRoutes } from "../../_router/app.routes";

const CardStyle = styled(Card)({
  padding: '24px 12px',

  [mediaQuery('mobile')]: {
    padding: '24px 20px'
  },
})

const GroupIconStyle = styled(GroupIcon)({
  cursor: 'pointer'
})

const CloseIconStyle = styled(CloseIcon)({
  cursor: 'pointer'
})

const htmlTextLinks: Array<HtmlTextLink> = [
  { value: 'here', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: 'ovdje' },
];

const MboPage = () => {
  const dispatch = useAppDispatch();
  const { formRef } = useForm();
  const [setInsuranceNumberMutation] = useMutation(setInsuranceNumber);
  const params = useParams<{ soId: string }>();
  const soId = params.soId as string;

  const [showInfoCard, setShowInfoCard] = useState(false);

  const handleInfoIconClick = () => {
    setShowInfoCard(!showInfoCard);
  };

  const handleSubmit = async (values: any) => {
    dispatch(setGlobalLoading(true));
    try {
      await setInsuranceNumberMutation({
        variables: {
          soId,
          insuranceNumber: values.insuranceNumber
        }
      });

      navigate(`${AppRoutes.MBO_THANK_YOU.fullPath}`);
    } catch (error) {
      console.error('Greška prilikom spremanja MBO-a ili dokumenta:', error);
    } finally {
      dispatch(setGlobalLoading(false));
    }
  };

  return (
    <Flex vertical gap={32}>
      <Flex gap={8} vertical>
        <Text type='xLarge' bold>{i18n.t('pages.mboPage.title')}</Text>
        <Text type='base'>
          {i18n.t('pages.mboPage.description')} <GroupIconStyle color={colors.primary} width={16} height={16} onClick={handleInfoIconClick} />
        </Text>
      </Flex>
      {showInfoCard && (
        <Card padding={12}>
          <Flex gap={12}>
            <HtmlText i18nKey="pages.mboPage.infoCard" links={htmlTextLinks} />
            <CloseIconStyle width={10} height={10} color={colors.icon2} onClick={() => setShowInfoCard(false)} />
          </Flex>
        </Card>
      )}
      <CardStyle radius={12}>
        <MboForm initialValues={{ insuranceNumber: '' }} ref={formRef} onSubmit={handleSubmit} />
      </CardStyle>
      <RequestAgentCardV2 title={`Nemaš ili ne možeš naći MBO?`} onButtonClick={() => dispatch(openCallMeModal())} />
    </Flex>
  );
}

export default MboPage;